import { render, staticRenderFns } from "./list.vue?vue&type=template&id=52ae5ecb&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=52ae5ecb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ae5ecb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ae5ecb')) {
      api.createRecord('52ae5ecb', component.options)
    } else {
      api.reload('52ae5ecb', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=52ae5ecb&scoped=true&", function () {
      api.rerender('52ae5ecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeGGL/list.vue"
export default component.exports